/* global axios */
import ApiClient from './ApiClient';

class TasksApi extends ApiClient {
  constructor() {
    super('tasks', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  create(task) {
    return axios.post(this.url, { task });
  }

  update(id, task) {
    return axios.patch(`${this.url}/${id}`, { task });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  complete(id) {
    return axios.post(`${this.url}/${id}/complete`);
  }

  reopen(id) {
    return axios.post(`${this.url}/${id}/reopen`);
  }
}

export default new TasksApi();
